import React from 'react'

function AboutUs() {
  return (
    <div className="container-fluid aboutus_fullpage pt-5">
        <div className="row justify-content-center">
            <div className="col-xl-10 col-md-11 col-11">
                <div className="row">
                    <div className="col-12">
                        <div className="row justify-content-md-between justify-content-center align-items-center">
                            <div className="col-xl-4 col-lg-5 col-md-6 hero_aboutus">
                                <div className="row">
                                <h1 className='anton'>For Founders, <br/><span className="text-primary">by a Founder.</span></h1>
                                <p>In 10 years of MS IT Park, LOOV delivered the biggest shift — solving team productivity, tracking, and accountability effortlessly.</p>
                                </div>
                            </div>
                            {/* <div className="col-lg-4 col-md-6 col-10">
                                <div className="row">
                                    <img src={require("../assets/aboutus/aboutusbanner.svg").default} alt="aboutus" />
                                </div>
                            </div> */}
                            <div className="col-12 main_allaboutcontent">
                                <div className="row p-md-4 px-2 py-4">
                                    <div className="d-flex justify-content-md-end mb-3">
                                        <img src={require("../assets/loov-logo-1.svg").default} alt="Logo" height="50" />
                                    </div>
                                    <p className='fw-bold'>Dear Founders, Owners, and Leaders,</p>
                                    <p className='fw-bold'>We know what it's like.</p>
                                    <span>As a Growing team at MS IT Park, we juggled multiple projects, clients, and deadlines — all while trusting our team to stay focused and deliver. But we needed clarity. We needed real-time insights. We needed proof of productivity, not assumptions.</span>
                                    <span>That’s why we created LOOV — a simple, powerful desktop monitoring solution that shows you exactly what your team is doing, without invading their space. With features like live screen view, automated screenshots, cam shots, and productivity analytics, we finally felt in control — not controlling.</span>
                                    <span>LOOV didn’t just help us track performance — it helped us grow.<br/>It brought transparency. It reduced micromanagement. It gave our clients more confidence in our delivery. And it gave us back the time we were wasting on follow-ups and guesswork.</span>
                                    <span>If you’re a business owner navigating growth and people management — LOOV was built for you.<br/>From one founder to another — we promise: once you use LOOV, you’ll never go back to guesswork.</span>
                                    
                                    <div className="d-flex align-items-start main_ownercontent justify-content-between">
                                        <img src={require("../assets/aboutus/owner.png")} alt="owner" />
                                        <div className="aboutownercontent">
                                            <p className='fw-bold'>With productivity,<br/>
                                                Sridharan Yuvaraja<br/>
                                                And the MS IT Park Team<br/>
                                                Built for ourselves. Shared with you.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
           <div class="video-container col-8 mt-3">
  <iframe
    src="https://www.youtube.com/embed/Ix1SsHvbGtA"
    title="YouTube video player"
    frameborder="0"
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
    allowfullscreen>
  </iframe>
</div>

        <div className="row p-0 m-0">
            
                        <div className='col-md-12 p-0 py-5'>
                            <div className='trail_box py-5 px-2'>
                                <h1>Start Monitoring Your Team Now!</h1>
                                <p>No More Guesswork — Track Activity, Boost Productivity, And Support Your Team Effortlessly.</p>
                                <div className='d-flex justify-content-center'>
                                {/* <a href='https://view.loov.in/sign-up' class="allhovebtn allhovebtn--svg js-animated-button text-white">
                                        <span class="allhovebtn--svg__label">Start Your Free Trial</span>
                                        <svg width="190" x="0px" y="0px" viewBox="0 0 60 60" class="allhovebtn--svg__circle">
                                          <circle fill="#9FCBFF" cx="30" cy="30" r="28.7" class="js-discover-circle"></circle>
                                        </svg>
                                        <svg x="0px" y="0px" preserveAspectRatio="none" viewBox="2 29.3 56.9 13.4" width="190" class="allhovebtn--svg__border">
                                          <g class="allhovebtn--svg__border--left js-discover-left-border">
                                            <path fill="none" stroke="#0092D3" stroke-width="0.5" stroke-miterlimit="1" d="M30.4,41.9H9c0,0-6.2-0.3-6.2-5.9S9,30.1,9,30.1h21.4"></path>
                                          </g>
                                          <g class="allhovebtn--svg__border--right js-discover-right-border">
                                            <path fill="none" stroke="#0092D3" stroke-width="0.5" stroke-miterlimit="1" d="M30.4,41.9h21.5c0,0,6.1-0.4,6.1-5.9s-6-5.9-6-5.9H30.4"></path>
                                          </g>
                                        </svg>
                                    </a> */}
             <a href='https://view.loov.in/sign-up' class="allhovebtn allhovebtn--svg js-animated-button text-white">
                                        <span class="allhovebtn--svg__label">Start Your Free Trial</span>
                                        <svg width="190" x="0px" y="0px" viewBox="0 0 60 60" class="allhovebtn--svg__circle">
                                          <circle fill="#9FCBFF" cx="30" cy="30" r="28.7" class="js-discover-circle"></circle>
                                        </svg>
                                        <svg x="0px" y="0px" preserveAspectRatio="none" viewBox="2 29.3 56.9 13.4" width="190" class="allhovebtn--svg__border">
                                          <g class="allhovebtn--svg__border--left js-discover-left-border">
                                            <path fill="none" stroke="#0092D3" stroke-width="0.5" stroke-miterlimit="1" d="M30.4,41.9H9c0,0-6.2-0.3-6.2-5.9S9,30.1,9,30.1h21.4"></path>
                                          </g>
                                          <g class="allhovebtn--svg__border--right js-discover-right-border">
                                            <path fill="none" stroke="#0092D3" stroke-width="0.5" stroke-miterlimit="1" d="M30.4,41.9h21.5c0,0,6.1-0.4,6.1-5.9s-6-5.9-6-5.9H30.4"></path>
                                          </g>
                                        </svg>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
        </div>
    </div>
  )
}

export default AboutUs
